<template>
  <div>
    <h1>Better world</h1>
  </div>
</template>

<script>
export default {
  methods: {
    test() {}
  }
}
</script>

<style lang="scss" scoped></style>
